import VersionModel from './version.ts';

export default class TasProgramTemplateVersionModel extends VersionModel {}
